import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-withoutradio',
  templateUrl: './privacyPolicy-withoutradio.component.html',
  styleUrls: ['./privacyPolicy-withoutradio.component.css']
})
export class PrivacyPolicyWithoutRadioComponent implements OnInit {
  @Input() lang: any
  platform: any

  ngOnInit(): void {
    this.platform = localStorage.getItem('platform');
  }

  clickGroup(id: any) {
    const elPoint: HTMLElement = document.getElementById(id + '-point')!;
    const elIconUp: HTMLElement = document.getElementById(id + '-icon-up')!;
    const elIconDown: HTMLElement = document.getElementById(id + '-icon-down')!;
    if (elPoint.classList.contains('d-none')) {
      elPoint.classList.remove("d-none");
      elPoint.classList.add("d-block");
      elIconUp.classList.remove("d-none");
      elIconUp.classList.add("d-block");
      elIconDown.classList.remove("d-block");
      elIconDown.classList.add("d-none");
    } else {
      elPoint.classList.remove("d-block");
      elPoint.classList.add("d-none");
      elIconUp.classList.remove("d-block");
      elIconUp.classList.add("d-none");
      elIconDown.classList.remove("d-none");
      elIconDown.classList.add("d-block");
    }
  }

}
